import GraphqlError from '~/components/GraphqlError';
import wrapError from '~/components/JavascriptError/JavascriptErrorHandler';
import LoadingArea from '~/components/LoadingArea';
import MissingPage from '~/components/MissingPage';
import { useFancyQuery } from '~/lib/graphql';

import Company from '../Show';
import query from './query.graphql';

const CompanyFromDomain = ({ domain }) => {
  const { data, loading, error, refetch } = useFancyQuery(query, {
    variables: { companiesSearchQuery: domain },
    returnPartialData: true,
  });

  if (error) {
    return (
      <div className="x-sidebar">
        <GraphqlError error={error} refetch={refetch} />;
      </div>
    );
  }

  if (loading) {
    return <LoadingArea className="x-sidebar" loading />;
  }

  if (!data?.companies?.edges?.[0]?.node?.id) {
    return <MissingPage className="x-sidebar" />;
  }

  return <Company id={data.companies.edges[0].node.id} />;
};

CompanyFromDomain.propTypes = {
  domain: PropTypes.string,
};

export default wrapError(CompanyFromDomain);
